import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { Button, Card, Col, Container, Row } from "reactstrap";
import API from "../../../helpers/API";
import NotificationManager from "../../../components/Common/NotificationManager";
import AuthSlider from "../authCarousel";

const CoverPasswReset = () => {
  const history = useHistory();

  const [openFields, setOpenFields] = useState(false);
  const [email, setEmail] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [newOtp, setNewOpt] = useState("");

  const getOpt = () => {
    const sendEmail = {
      email: email,
    };
    API.post("/api/forgot/password/", sendEmail)
      .then((response) => {
        const data = response.data;
        setOpenFields(true);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const verifyOtp = async () => {
    const passwordObj = {
      email: email,
      new_password: newPassword,
      confirm_password: confirmPassword,
      // otp: newOtp,
    };
    await API.post("/api/forgot/password/verify/", passwordObj)
      .then((response) => {
        const data = response.data;
        NotificationManager.success(
          "",
          "Password updated successfully.",
          3000,
          null,
          null,
          ""
        );
        history.push("/login");
      })
      .catch((err) => {
        console.log(err);
      });

    setOpenFields(false);
    setNewOpt("");
  };

  return (
    <React.Fragment>
      <div className="auth-page-wrapper">
        <div className="bg-overlay"></div>
        <div className="auth-page-content overflow-hidden pb-0">
          <Row>
            <Col lg={12}>
              <Card className="overflow-hidden m-0" style={{ height: "100vh" }}>
                <Row className="justify-content-center g-0 h-100">
                  <AuthSlider />

                  <Col lg={6} style={{ margin: "auto" }}>
                    <div className="p-lg-5 p-4">
                      <h1 className="text-dark mb-3">
                        Enter your email address
                      </h1>

                      <div className="mt-2 text-center">
                        <lord-icon
                          src="https://cdn.lordicon.com/rhvddzym.json"
                          trigger="loop"
                          colors="primary:#0ab39c"
                          className="avatar-xl"
                          style={{ width: "120px", height: "120px" }}
                        ></lord-icon>
                      </div>
                      <div className="p-2">
                        <form>
                          <div className="">
                            <label className="form-label">Email Address</label>
                            <input
                              type="email"
                              className="form-control"
                              id="email"
                              required
                              onChange={(e) => setEmail(e.target.value)}
                            />
                            {openFields && (
                              <div className="d-flex justify-content-end align-items-center mt-3">
                                <button
                                  className="btn btn-success"
                                  onClick={(e) => {
                                    getOpt();
                                  }}
                                >
                                  Resend OTP
                                </button>
                              </div>
                            )}
                          </div>

                          {openFields && (
                            <>
                              <div className="mb-4">
                                <label className="form-label">OTP</label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="otp"
                                  placeholder="Enter OTP"
                                  required
                                  onChange={(e) => setNewOpt(e.target.value)}
                                />
                              </div>
                              <div className="mb-4">
                                <label className="form-label">
                                  Change Password
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="change-password"
                                  placeholder="Enter New Password"
                                  required
                                  onChange={(e) =>
                                    setNewPassword(e.target.value)
                                  }
                                />
                              </div>
                              <div className="mb-4">
                                <label className="form-label">
                                  Confirm New Password
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  id="confirm_new_password"
                                  placeholder=""
                                  required
                                  onChange={(e) => {
                                    setConfirmPassword(e.target.value);
                                  }}
                                />
                              </div>
                            </>
                          )}

                          <div className="text-center mt-4">
                            <Button
                              color="success"
                              className="w-100"
                              type="submit"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();

                                if (openFields) verifyOtp();
                                else getOpt();
                              }}
                            >
                              {openFields === true ? "Submit" : "Send OTP"}
                            </Button>
                          </div>
                        </form>
                      </div>

                      <div className="mt-5 text-left">
                        <p className="mb-0">
                          Remember the password?
                          <Link
                            to="/auth-signin-cover"
                            className="fw-bold text-dark text-decoration-underline"
                          >
                            {" "}
                            Sign in{" "}
                          </Link>{" "}
                        </p>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </React.Fragment>
  );
};

export default CoverPasswReset;
